export default "__VITE_ASSET__CDuNvX8___"